import { EducationScreenLazy } from './educationScreenLazy';

const props = [];

export const EducationScreenDirective = (reactDirective) => reactDirective(EducationScreenLazy, props);
EducationScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('educationScreen', EducationScreenDirective);